import axios from "axios";
export default {
    namespaced: true,
    state: {
        dialog: false,
        estadosParte: [],
        loadingEstadosParte: false,
    },
    mutations: {
        SET_DIALOG(state, mostrar) {
            state.dialog = mostrar
        },
        SET_ESTADOS_PARTE(state, estados) {
            state.estadosParte = estados
        },
        SET_LOADING(state, value) {
            state.loadingEstadosParte = value
        }
    },
    actions: {
        setDialog({
            commit
        }, mostrar) {
            commit('SET_DIALOG', mostrar);
        },
        getEstadosParte({
            commit,
            dispatch
        }) {
            commit('SET_LOADING', true)
            axios.get(`api/estadospartes`)
                .then((res) => {
                    let estados = res.data.map((item) => {
                        return {
                            value: item.id,
                            text: item.estado,
                            color: item.color,
                        };
                    });
                    commit('SET_ESTADOS_PARTE', estados)
                })
                .catch((err) => {
                    console.log(err);
                    dispatch('setSnackbar', {
                        tipo: "error",
                        mensaje: "Error. No se han podido recuperar los estados de los partes",
                    });
                })
                .finally(() => {
                    commit('SET_LOADING', false)
                });
        },

    },
    getters: {
        estadosParte: state => state.estadosParte,
        loadingEstados: state => state.loadingEstadosParte
    }
}